import GalleryComponen from "./GalleryComponent";
export default GalleryComponen;